import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
  success: false,
};

export const enquirySlice = createSlice({
  name: 'enquiry',
  initialState,
  reducers: {
    addEnquiry: (state) => {
      state.loading = true;
      state.success = false;
    },
    successEnquiry: (state) => {
      state.loading = false;
      state.success = true;
    },
    failedEnquiry: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },
    resetEnquiry: (state) => {
      state.success = false;
      state.error = null;
    }
  },
});

export const { addEnquiry, successEnquiry, failedEnquiry, resetEnquiry } = enquirySlice.actions;
export default enquirySlice.reducer;
